export const NO_IMAGE_ID = "none";
